import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
const ClassesUKGtoV = () => {
  useEffect(() => {
    document.title = "Classes UKG-V -  The Air Force School Subroto Park";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li>Classes UKG-V</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1> Junior Syllabus 2025-2026 </h1>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <h6>UKG </h6>
              <ul className="list mainlist">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classukg-english.pdf"
                    target="_blank"
                  >
                    {" "}
                    English{" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classukg-hindi.pdf"
                    target="_blank"
                  >
                    {" "}
                    Hindi{" "}
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classukg-maths.pdf"
                    target="_blank"
                  >
                    {" "}
                    Maths{" "}
                  </Link>{" "}
                </li>
              </ul>

              <h6>Class I</h6>
              <ul className="list mainlist">
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classI-english.pdf"
                    target="_blank"
                  >
                    English{" "}
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classI-hindi.pdf"
                    target="_blank"
                  >
                    Hindi{" "}
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classI-math.pdf"
                    target="_blank"
                  >
                    Maths{" "}
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classI-Evs.pdf"
                    target="_blank"
                  >
                    Evs{" "}
                  </Link>{" "}
                </li>
              </ul>

              <h6>Class II</h6>
              <ul className="list mainlist">
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classII-english.pdf"
                    target="_blank"
                  >
                    English{" "}
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classII-hindi.pdf"
                    target="_blank"
                  >
                    Hindi{" "}
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classII-math.pdf"
                    target="_blank"
                  >
                    Maths{" "}
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classII-Evs.pdf"
                    target="_blank"
                  >
                    Evs{" "}
                  </Link>{" "}
                </li>
              </ul>

              <h6>Class III</h6>
              <ul className="list mainlist">
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classIII-english.pdf"
                    target="_blank"
                  >
                    English{" "}
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classIII-hindi.pdf"
                    target="_blank"
                  >
                    Hindi{" "}
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classIII-math.pdf"
                    target="_blank"
                  >
                    Maths{" "}
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classIII-Evs.pdf"
                    target="_blank"
                  >
                    Evs{" "}
                  </Link>{" "}
                </li>
              </ul>

              <h6>Class IV</h6>
              <ul className="list mainlist">
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classIV-english.pdf"
                    target="_blank"
                  >
                    English{" "}
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classIV-hindi.pdf"
                    target="_blank"
                  >
                    Hindi{" "}
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classIV-math.pdf"
                    target="_blank"
                  >
                    Maths{" "}
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classIV-Evs.pdf"
                    target="_blank"
                  >
                    Evs{" "}
                  </Link>{" "}
                </li>
              </ul>

              <h6>Class V</h6>
              <ul className="list mainlist">
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classV-english.pdf"
                    target="_blank"
                  >
                    English{" "}
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classV-hindi.pdf"
                    target="_blank"
                  >
                    Hindi{" "}
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classV-math.pdf"
                    target="_blank"
                  >
                    Maths{" "}
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/classV-Evs.pdf"
                    target="_blank"
                  >
                    Evs{" "}
                  </Link>{" "}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ClassesUKGtoV;
